var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2389 18.451L13.4419 3.816C13.1349 3.305 12.5959 3 11.9999 3C11.4039 3 10.8649 3.305 10.5589 3.815L1.76088 18.451C1.44888 18.97 1.44088 19.619 1.73888 20.146C2.03588 20.673 2.59688 21 3.20288 21H20.7979C21.4029 21 21.9649 20.673 22.2619 20.146C22.5599 19.619 22.5509 18.97 22.2389 18.451ZM12.4999 18H11.4999C11.2239 18 10.9999 17.776 10.9999 17.5V16.5C10.9999 16.224 11.2239 16 11.4999 16H12.4999C12.7759 16 12.9999 16.224 12.9999 16.5V17.5C12.9999 17.776 12.7759 18 12.4999 18ZM11.9999 14C11.4479 14 10.9999 13.552 10.9999 13V10C10.9999 9.448 11.4479 9 11.9999 9C12.5519 9 12.9999 9.448 12.9999 10V13C12.9999 13.552 12.5519 14 11.9999 14Z",
    fill: "#F18C46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError1);
export default __webpack_public_path__ + "static/media/error1.821158ea.svg";
export { ForwardRef as ReactComponent };